export interface Order {
    id?: number;
    uuid?: string;
    tableId: string;
    clientName?: string;
    status?: string;
    items?: any
    currentOrder?: string;
    enabled?: boolean;
    totalAmount?: number;
    orderDetail?: any;
}

export class ItemOrder {
    qty: number = 0;
    uuid: string = '';
    orderUuid?: string = '';
    menuProductUuid?: string = '';
    name: string = '';
    price: number = 0;
    description?: string = '';
    itemStatusSlug?: string = 'pending';
    menuProductOption?: { uuid: string; name: string; priceDelta: number };
    menuProductOptionUuid?: string;
    // Creation timestamp (from backend if available)
    createdAt?: string | number | Date;
    // Flow helpers (computed on load)
    allowedNextStatuses?: string[] = [];
    canEdit?: boolean = true;      // only when pending
    canCancel?: boolean = false;   // allowed when 'sent'
}